import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useEntityFromRoute } from '@/common/hooks/route/useEntityFromRoute';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { TitleButton } from './TitleButton';
import { usePrincipal } from '@/common/principal/PrincipalContext';


export const ValButton = ({ selectedEntityIds, disabled }) => {

  const { entityObj, hist, asOfDate } = useEntityMgr();

  const rsrc = useRsrc();
  const module = useModuleFromRoute();
  const entity = useEntityFromRoute();

  // Only render if the use has appropriate Role
  const { hasRole } = usePrincipal();
  if (!hasRole(`${module.toUpperCase()}_${entity}_SAVE`)) return;

  const validate = () => {

    const reqParam = {
      ids: selectedEntityIds ?? [entityObj.id],
      entity: entity
    }
    const job = {
      name: 'Validation',
      module: module,
      rsrcCode: 'DEFAULT_VAL_ACTION_PLUGIN',
      entity: entity,
      entityId: entityObj?.id,
      reqParamJson: JSON.stringify(reqParam),
      cat: 'ACTION'
    }

    rsrc.save('skdr', 'JOB', job).then(job => {
      rsrc.start(job.id);
    })
  }

  return (
    <TitleButton
      dataTestId={'val-button'}
      icon={fas.faShieldCheck}
      toolTip="Validate"
      disabled={hist || asOfDate || disabled}
      onClick={validate}
    />
  )
}